import React, { useState, useEffect } from "react";

const GstInlineSetting = ({ gstData, setGstData, handleGstSubmit }) => {
  const [gstPercent, setGstPercent] = useState("");

  useEffect(() => {
    if (gstData?.gstPercent) {
      setGstPercent(gstData.gstPercent);
    }
  }, [gstData]);

  const handleChange = (e) => {
    setGstPercent(e.target.value);
  };

  const handleSave = () => {
    if (!gstPercent) return alert("Please enter GST percentage");
    handleGstSubmit({ ...gstData, gstPercent });
  };

  return (
    <div className="gst-setting-container">
      <label className="gst-setting-label">GST Percentage (%)</label>
      <div className="gst-setting-inline">
        <input
          type="number"
          className="gst-setting-input"
          value={gstPercent}
          onChange={handleChange}
          placeholder="Enter GST %"
        />
        <button className="gst-setting-save-btn" onClick={handleSave}>
          Save
        </button>
      </div>
    </div>
  );
};

export default GstInlineSetting;
